import type { ReceiptTemplate } from '../schema';

export const googleTemplate: ReceiptTemplate = {
  id: 'google',
  name: 'Google Receipt',
  brand: 'GOOGLE',
  description: 'Google Play Store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'goo-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'GOOGLE PLAY',
        businessNameFontSize: 18,
        addressLines: ['PURCHASE RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'goo-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order #:', value: 'GP-847291034' },
          { id: 'account', label: 'Account:', value: 'john@gmail.com' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'goo-item',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'ITEM: Premium App Subscription\nDEVELOPER: Acme Apps LLC\nTYPE: In-App Purchase', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'goo-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'item', label: 'PURCHASE', value: '4.99', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '0.41', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '5.40', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'goo-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'GOOGLE PAY', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'goo-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'PURCHASE COMPLETE\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

